import { Cookie } from 'lucide-react';
import SEOHead from '@/components/SEOHead';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead
        title="Çerez Politikası | TesisKirala.com"
        description="TesisKirala.com Çerez Politikası. Web sitemizde kullanılan çerezler hakkında bilgi."
        canonicalPath="/cerez-politikasi"
      />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Cookie className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Çerez Politikası
          </h1>
          <p className="text-emerald-100">
            Son güncelleme: Aralık 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-slate max-w-none">
            
            <h2>1. Çerez Nedir?</h2>
            <p>
              Çerezler, web sitelerinin cihazınıza yerleştirdiği küçük metin dosyalarıdır. 
              Bu dosyalar, siteyi ziyaret ettiğinizde deneyiminizi kişiselleştirmek ve site 
              performansını analiz etmek için kullanılır.
            </p>

            <h2>2. Kullandığımız Çerez Türleri</h2>
            
            <h3>2.1. Zorunlu Çerezler</h3>
            <p>
              Bu çerezler sitenin düzgün çalışması için gereklidir ve kapatılamaz.
            </p>
            <table className="w-full border-collapse border border-slate-200">
              <thead>
                <tr className="bg-slate-50">
                  <th className="border border-slate-200 p-2 text-left">Çerez Adı</th>
                  <th className="border border-slate-200 p-2 text-left">Amaç</th>
                  <th className="border border-slate-200 p-2 text-left">Süre</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-slate-200 p-2">session_token</td>
                  <td className="border border-slate-200 p-2">Oturum yönetimi</td>
                  <td className="border border-slate-200 p-2">7 gün</td>
                </tr>
                <tr>
                  <td className="border border-slate-200 p-2">csrf_token</td>
                  <td className="border border-slate-200 p-2">Güvenlik</td>
                  <td className="border border-slate-200 p-2">Oturum</td>
                </tr>
              </tbody>
            </table>

            <h3>2.2. Performans Çerezleri</h3>
            <p>
              Bu çerezler, ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olur.
            </p>
            <table className="w-full border-collapse border border-slate-200">
              <thead>
                <tr className="bg-slate-50">
                  <th className="border border-slate-200 p-2 text-left">Çerez Adı</th>
                  <th className="border border-slate-200 p-2 text-left">Amaç</th>
                  <th className="border border-slate-200 p-2 text-left">Süre</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-slate-200 p-2">_ga</td>
                  <td className="border border-slate-200 p-2">Google Analytics - Ziyaretçi tanımlama</td>
                  <td className="border border-slate-200 p-2">2 yıl</td>
                </tr>
                <tr>
                  <td className="border border-slate-200 p-2">_gid</td>
                  <td className="border border-slate-200 p-2">Google Analytics - Oturum tanımlama</td>
                  <td className="border border-slate-200 p-2">24 saat</td>
                </tr>
              </tbody>
            </table>

            <h3>2.3. İşlevsellik Çerezleri</h3>
            <p>
              Bu çerezler, tercihlerinizi hatırlamamıza ve deneyiminizi kişiselleştirmemize olanak tanır.
            </p>
            <table className="w-full border-collapse border border-slate-200">
              <thead>
                <tr className="bg-slate-50">
                  <th className="border border-slate-200 p-2 text-left">Çerez Adı</th>
                  <th className="border border-slate-200 p-2 text-left">Amaç</th>
                  <th className="border border-slate-200 p-2 text-left">Süre</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-slate-200 p-2">preferred_city</td>
                  <td className="border border-slate-200 p-2">Tercih edilen şehir</td>
                  <td className="border border-slate-200 p-2">30 gün</td>
                </tr>
                <tr>
                  <td className="border border-slate-200 p-2">campaign_dismissed</td>
                  <td className="border border-slate-200 p-2">Kampanya popup tercihi</td>
                  <td className="border border-slate-200 p-2">7 gün</td>
                </tr>
              </tbody>
            </table>

            <h2>3. Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
            <p>
              Çerezleri tarayıcı ayarlarınızdan yönetebilirsiniz. Çoğu tarayıcı şunları yapmanıza olanak tanır:
            </p>
            <ul>
              <li>Tüm çerezleri görmek ve silmek</li>
              <li>Çerezleri engellemek</li>
              <li>Belirli sitelerden gelen çerezlere izin vermek</li>
              <li>Üçüncü taraf çerezlerini engellemek</li>
            </ul>

            <h3>Tarayıcı Ayarları</h3>
            <ul>
              <li><strong>Chrome:</strong> Ayarlar → Gizlilik ve güvenlik → Çerezler</li>
              <li><strong>Firefox:</strong> Seçenekler → Gizlilik ve Güvenlik → Çerezler</li>
              <li><strong>Safari:</strong> Tercihler → Gizlilik → Çerezler</li>
              <li><strong>Edge:</strong> Ayarlar → Gizlilik → Çerezler</li>
            </ul>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 my-6">
              <p className="text-amber-800 mb-0">
                <strong>Uyarı:</strong> Zorunlu çerezleri engellerseniz, sitemizdeki bazı özellikler 
                düzgün çalışmayabilir.
              </p>
            </div>

            <h2>4. Üçüncü Taraf Çerezleri</h2>
            <p>
              Sitemizde aşağıdaki üçüncü taraf hizmetleri kullanılmaktadır:
            </p>
            <ul>
              <li><strong>Google Analytics:</strong> Site trafiği analizi</li>
              <li><strong>Google reCAPTCHA:</strong> Bot koruması</li>
            </ul>

            <h2>5. Politika Güncellemeleri</h2>
            <p>
              Bu çerez politikasını zaman zaman güncelleyebiliriz. Değişiklikler bu sayfada yayınlanacaktır.
            </p>

            <h2>6. İletişim</h2>
            <p>
              Çerez politikamız hakkında sorularınız için <a href="mailto:tesiskirala@gmail.com" className="text-emerald-700">tesiskirala@gmail.com</a> 
              adresinden bize ulaşabilirsiniz.
            </p>

          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
